module.exports = __webpack_public_path__ + "static/img/CL@3x.a7650337.jpg";